export default __webpack_public_path__ + "static/media/billboardLuxury.137ed2a7.svg";